import { render, staticRenderFns } from "./CustomerPanel.vue?vue&type=template&id=47bdf553&"
import script from "./CustomerPanel.vue?vue&type=script&lang=js&"
export * from "./CustomerPanel.vue?vue&type=script&lang=js&"
import style0 from "../../styles/customer-panel.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports